import { render, staticRenderFns } from "./IntegrationSidebar.vue?vue&type=template&id=3ea1fad3&scoped=true"
import script from "./IntegrationSidebar.vue?vue&type=script&lang=js"
export * from "./IntegrationSidebar.vue?vue&type=script&lang=js"
import style0 from "./IntegrationSidebar.vue?vue&type=style&index=0&id=3ea1fad3&prod&lang=scss"
import style1 from "./IntegrationSidebar.vue?vue&type=style&index=1&id=3ea1fad3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea1fad3",
  null
  
)

export default component.exports